import { t } from 'translations'

export interface Language {
    value: string
    name: string
}

// A function, not a constant: the names are translated at call time.
export const getLanguagesDict = (): Language[] => [
    {
        name: t('utils.languages.en'),
        value: 'en',
    },
    {
        name: t('utils.languages.nl'),
        value: 'nl',
    },
    {
        name: t('utils.languages.de'),
        value: 'de',
    },
    {
        name: t('utils.languages.fr'),
        value: 'fr',
    },
    {
        name: t('utils.languages.es'),
        value: 'es',
    },
    {
        name: t('utils.languages.esUS'),
        value: 'es-US',
    },
    {
        name: t('utils.languages.ca'),
        value: 'ca',
    },
    {
        name: t('utils.languages.pt'),
        value: 'pt',
    },
    {
        name: t('utils.languages.fi'),
        value: 'fi',
    },
    {
        name: t('utils.languages.ru'),
        value: 'ru',
    },
    {
        name: t('utils.languages.sv'),
        value: 'sv',
    },
    {
        name: t('utils.languages.it'),
        value: 'it',
    },
    {
        name: t('utils.languages.pl'),
        value: 'pl',
    },
    {
        name: t('utils.languages.enUS'),
        value: 'en-US',
    },
    {
        name: t('utils.languages.nlBE'),
        value: 'nl-BE',
    },
    {
        name: t('utils.languages.cs'),
        value: 'cs',
    },
    {
        name: t('utils.languages.mt'),
        value: 'mt',
    },
    {
        name: t('utils.languages.zh'),
        value: 'zh',
    },
    {
        name: t('utils.languages.ar'),
        value: 'ar',
    },
    {
        name: t('utils.languages.arSA'),
        value: 'ar-SA',
    },
    {
        name: t('utils.languages.arSA'),
        value: 'ar-sa',
    },
    {
        name: t('utils.languages.sl'),
        value: 'sl',
    },
    {
        name: t('utils.languages.el'),
        value: 'el',
    },
    {
        name: t('utils.languages.sq'),
        value: 'sq',
    },
    {
        name: t('utils.languages.hr'),
        value: 'hr',
    },
]

export const rtlLanguages = ['ar', 'ar-sa', 'ar-SA']
export const ensureRightLocaleCasing = (locale: string) => {
    return locale
        .split('-')
        .map((l, i) => {
            if (i === 0) {
                return l.toLowerCase()
            } else {
                return l.toUpperCase()
            }
        })
        .join('-')
}
